import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import SidebarQuestionnaire from "../SidebarQuestionnaire";
import {
  setSelectedDomain,
  setSelectedQuestion,
  setSelectedGoal,
} from "../../../slices/Employee/survey-CRR.slice";
import { getGoalsData } from "../../../slices/Employee/goals.slice";
import { getLocalStorage } from "../../../helpers/utils";
import { getEmployeeDashboardData } from "../../../slices/Employee/employeeDashboard.slice";
import { setAssessmentComplete } from "../../../slices/Admin/survey-CSF.slice";

export default function CRRSidebar({
  selectedSurvey,
  isActiveSurvey,
  ...rest
}) {
  const dispatch = useDispatch();
  const storedSurvey = getLocalStorage("SELECTED-SURVEY") || {};
  const { id: surveyId, csf_survey_status } = selectedSurvey || storedSurvey;

  const { domains } = useSelector(
    (state) => state.employeeDashboard.employeeDashboardData || {}
  );

  const { selectedGoal, selectedDomain } = useSelector(
    (state) => state.CRRsurvey
  );
  const { isCSFComplete } = useSelector((state) => state.CSFSurvey);
  const { goalsData, goalsStatusData } = useSelector((state) => state.goals);

  useEffect(() => {
    const csfComplete = csf_survey_status === "completed"; //from localstorage
    if (csfComplete && !isCSFComplete) {
      dispatch(setAssessmentComplete(true));
    }
  }, []);

  useEffect(() => {
    if (isActiveSurvey) {
      if (!domains || domains.length === 0) {
        dispatch(getEmployeeDashboardData(surveyId || ""));
      } else {
        const initialDomain = selectedDomain?.id ? selectedDomain : domains[0];
        dispatch(setSelectedDomain(initialDomain));
      }
    }
  }, [domains, selectedDomain, surveyId, isActiveSurvey]);

  // Fetch goals whenever selected domain changes
  useEffect(() => {
    if (isActiveSurvey && selectedDomain?.id) {
      dispatch(getGoalsData(selectedDomain.id, surveyId));
    }
  }, [selectedDomain?.id, surveyId, isActiveSurvey]);

  // Handlers
  const handleDomainClick = (domain) => dispatch(setSelectedDomain(domain));
  const handleGoalClick = (goal) => dispatch(setSelectedGoal(goal));
  const handleQuestionClick = (question) =>
    dispatch(setSelectedQuestion(question));
  return (
    <SidebarQuestionnaire
      domains={domains}
      goalsData={goalsData}
      goalsStatusData={goalsStatusData}
      selectedDomainIndex={selectedDomain?.id}
      selectedGoalID={selectedGoal?.id}
      handleGoalClick={handleGoalClick}
      handleDomainClick={handleDomainClick}
      handleQuestionClick={handleQuestionClick}
      selectedSurvey={surveyId}
      isActiveSurvey={isActiveSurvey}
      assessmentName="CRR Assessment"
      isDisabled={!isCSFComplete} //disable crr assessment if csf is not complete
      {...rest}
    />
  );
}
